import React, {memo, useState, useEffect, useMemo, useRef} from "../../../__snowpack__/pkg/react.js";
import {Modal, Button, Spin, Tooltip} from "../../../__snowpack__/pkg/antd.js";
import {injectIntl, FormattedMessage} from "../../../__snowpack__/pkg/react-intl.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {useLocation} from "../../../__snowpack__/pkg/react-router-dom.js";
import qs from "../../../__snowpack__/pkg/query-string.js";
import {localeMessage} from "./i18n.js";
import {useIntlTyped} from "../../lib/useIntlTyped.js";
import {IconSuccess} from "../../../__snowpack__/pkg/@genieui-react/icon.js";
import {useUpdateRoute} from "../../lib/useIframe.js";
import {getUsercountryCode} from "../../lib/filter.js";
import {CHANNEL_ID_ENUM} from "../../enums/channel.js";
const CloneResultsModalStyled = styled.div`
  .results-content {
    &-success {
      margin-top: 24px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      b {
        display: inline-block;
        padding-top: 16px;
        font-size: 16px;
      }
    }
    &-list {
      background: rgba(245, 245, 245, 0.5);
      padding: 24px;
      /* margin-left: 30px;
      margin-right: 30px; */
      .list-item {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        font-size: 14px;
        color: #5a6977;
        .store-name {
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 150px;
        }
        .success-desc {
          padding-left: 16px;
          .success-count-green {
            color: #52c41a;
            padding-right: 4px;
          }
          .success-count-error {
            color: red;
            padding-right: 4px;
          }
          .success-tip {
            color: #5a6977;
          }
        }
      }
    }
    &-btn {
      margin-top: 24px;
      text-align: center;
    }
  }
`;
const CloneResultsModal = memo((props) => {
  const {updateRoute} = useUpdateRoute();
  const {CopyTaskInfo, IsCopySuccessVisible, FormUrl} = props;
  const channelId = CopyTaskInfo?.CheckChannelId;
  const {formatMessage, formatMessageMock} = useIntlTyped(localeMessage);
  const {search, pathname} = useLocation();
  const queries = useMemo(() => qs.parse(search), [search]);
  const [ResultsList, setResultsList] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [OperationStatus, setOperationStatus] = useState("IN_PROCESS");
  const refOperationStatus = useRef(OperationStatus);
  refOperationStatus.current = OperationStatus;
  const haveSuccessFlag = useMemo(() => {
    let flag = false;
    if (ResultsList.length) {
      flag = ResultsList.some((res) => "successProductIds" in res && res.successProductIds?.length);
    }
    return flag;
  }, [ResultsList]);
  const editNow = () => {
    let productIds = CopyTaskInfo.productIds;
    let productList = [];
    let shopIds = [];
    let firstCountryCode = "";
    if (ResultsList && ResultsList.length) {
      productIds = [];
    }
    ResultsList.forEach((el) => {
      if (!firstCountryCode) {
        firstCountryCode = el.countryCode;
      }
      if (firstCountryCode == el.countryCode) {
        shopIds.push(el.shopId);
        el.successProductIds.forEach((inner) => {
          productIds.push(inner);
          productList.push({
            id: inner,
            channelId: el.channelId,
            shopId: el.shopId
          });
        });
      }
    });
    const params = {
      channelId,
      productIds
    };
    const countryCode = getUsercountryCode();
    const catcheKey = Math.random().toString(36).slice(-8);
    const massedtiproducts = JSON.stringify(params);
    localStorage.setItem("massedtiproducts" + catcheKey, massedtiproducts);
    const categoryList = JSON.stringify(productList);
    localStorage.setItem("categoryList" + catcheKey, categoryList);
    queries.fromurl = FormUrl + search;
    queries.catcheKey = catcheKey;
    queries.status = "DRAFT";
    queries.countryCode = firstCountryCode || "ID";
    queries.channelId = channelId;
    queries.shopIds = qs.stringify(shopIds);
    let name = "";
    switch (channelId) {
      case "SHOPIFY_ID":
        name = "Shopify";
        break;
      default:
        break;
    }
    if (channelId === CHANNEL_ID_ENUM.SHOPEE) {
      localStorage.setItem("shopeeSelectedProductList", JSON.stringify(productList));
      updateRoute(`product-shopee-mass-edit-category-attribute?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
    } else if (channelId === CHANNEL_ID_ENUM.TIKTOK) {
      const tiktokProductList = [];
      ResultsList.forEach((item) => {
        item.successProductIds.forEach((inner) => {
          tiktokProductList.push({
            id: inner,
            channelId: null,
            shopId: item.shopId
          });
        });
      });
      localStorage.setItem("tiktokSelectedProductList", JSON.stringify(tiktokProductList));
      updateRoute(`product-tiktok-mass-edit-category-attribute?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
    } else if (channelId == CHANNEL_ID_ENUM.WOO_COMMERCE) {
      localStorage.setItem("wooProductList", JSON.stringify(productList));
      updateRoute(`product-woo-commerce/mass-edit-category?${qs.stringify({
        status: "DRAFT"
      })}`);
    } else if (channelId == CHANNEL_ID_ENUM.LAZADA) {
      sessionStorage.setItem("lazadaMassEditProductIds", JSON.stringify(productIds));
      updateRoute(`product-lazada-mass-category?${qs.stringify({
        status: "DRAFT",
        ...CopyTaskInfo?.countryCode || firstCountryCode ? {countryCode: CopyTaskInfo?.countryCode || firstCountryCode} : {}
      })}`);
    } else if (channelId == CHANNEL_ID_ENUM.TOKOPEDIA) {
      sessionStorage.setItem("product-tokopedia-mass-edit-ids", JSON.stringify(productIds));
      updateRoute(`product-tokopedia-mass-edit-category-attribute?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
    } else if (channelId == CHANNEL_ID_ENUM.BUKALAPAK) {
      sessionStorage.setItem("product-bukalapak-mass-edit-ids", JSON.stringify(productIds));
      updateRoute(`product-bukalapak-mass-edit-category-attribute?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
    } else {
      updateRoute(`product/${name}/mass-category?${qs.stringify(queries)}`);
    }
  };
  const handelViewNow = () => {
    const channelId2 = CopyTaskInfo?.CheckChannelId;
    let channelIds = {};
    if (channelId2) {
      channelIds = {
        channelId: channelId2
      };
    }
    const query = qs.stringify(Object.assign({}, queries, {
      status: "DRAFT",
      shopIds: qs.stringify(CopyTaskInfo.shopIds),
      page: 1,
      ...channelIds
    }));
    if (channelId2 === CHANNEL_ID_ENUM.BUKALAPAK) {
      updateRoute(`product-bukalapak?status=DRAFT`);
    }
    if (channelId2 === CHANNEL_ID_ENUM.SHOPIFY) {
      updateRoute(`product-shopify?${qs.stringify({status: "DRAFT"})}`);
    } else if (channelId2 === CHANNEL_ID_ENUM.TOKOPEDIA) {
      updateRoute(`product-tokopedia?${qs.stringify({status: "DRAFT"})}`);
    } else if (channelId2 === CHANNEL_ID_ENUM.BLIBLI) {
      updateRoute(`product-blibli?${qs.stringify({status: "DRAFT"})}`);
    } else if (channelId2 === CHANNEL_ID_ENUM.LAZADA) {
      updateRoute(`product-lazada?${qs.stringify({status: "DRAFT"})}`);
    } else {
      updateRoute(`product/${CopyTaskInfo.CheckChannel}?${query}`);
    }
  };
  useEffect(() => {
    if (CopyTaskInfo.taskId) {
      setResultsList(CopyTaskInfo.taskId);
    }
  }, [CopyTaskInfo]);
  const handelCancelResults = (type) => {
    if (type) {
      const query = qs.stringify(queries);
    } else {
      clearInterval(window.timer);
      props.handelCancelResults();
    }
  };
  const handelCancelToDrafts = () => {
    let channelIds = {};
    if (channelId) {
      channelIds = {
        channelId
      };
    }
    const query = qs.stringify(Object.assign({}, queries, {
      status: "DRAFT",
      shopIds: qs.stringify(CopyTaskInfo.shopIds),
      page: 1,
      ...channelIds
    }));
    if (channelId === CHANNEL_ID_ENUM.SHOPEE) {
      updateRoute(`product-shopee?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.TIKTOK) {
      updateRoute(`product-tiktok?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.WOO_COMMERCE) {
      updateRoute(`product-woo-commerce?${qs.stringify({
        status: "DRAFT",
        countryCode: CopyTaskInfo?.countryCode
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.SHOPIFY) {
      updateRoute(`product-shopify?${qs.stringify({
        status: "DRAFT"
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.TOKOPEDIA) {
      updateRoute(`product-tokopedia?${qs.stringify({
        status: "DRAFT"
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.BUKALAPAK) {
      updateRoute(`product-bukalapak?${qs.stringify({
        status: "DRAFT"
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.BLIBLI) {
      updateRoute(`product-blibli?${qs.stringify({
        status: "DRAFT"
      })}`);
      handelCancelResults(false);
    } else if (channelId === CHANNEL_ID_ENUM.LAZADA) {
      updateRoute(`product-lazada?${qs.stringify({
        status: "DRAFT"
      })}`);
      handelCancelResults(false);
    } else {
      updateRoute(`product/${CopyTaskInfo.CheckChannel}?${query}`);
    }
  };
  return /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "result"}),
    footer: null,
    width: 490,
    bodyStyle: {padding: "16px 24px"},
    onCancel: () => handelCancelResults(false),
    visible: IsCopySuccessVisible
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: IsLoading
  }, IsLoading ? /* @__PURE__ */ React.createElement("div", {
    style: {height: 200}
  }) : /* @__PURE__ */ React.createElement(CloneResultsModalStyled, {
    className: "results-content"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "results-content-success"
  }, /* @__PURE__ */ React.createElement(IconSuccess, {
    type: "check-circle",
    width: 48,
    height: 48,
    style: {color: "#52c41a", fontSize: 48}
  }), /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: "result",
    tagName: "b"
  })), Array.isArray(ResultsList) && ResultsList.length > 0 && /* @__PURE__ */ React.createElement("div", {
    className: "results-content-list"
  }, ResultsList.map((item, index) => /* @__PURE__ */ React.createElement(React.Fragment, null, item.successProductIds.length > 0 && /* @__PURE__ */ React.createElement("div", {
    className: "list-item",
    key: item.shopName
  }, /* @__PURE__ */ React.createElement(Tooltip, {
    title: item.shopName || "-"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "store-name"
  }, item.shopName, ":")), /* @__PURE__ */ React.createElement("div", {
    className: "success-desc"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "success-count-green"
  }, item.successProductIds.length), /* @__PURE__ */ React.createElement("span", {
    className: "success-tip"
  }, formatMessage({
    id: "copyAsDraftTip"
  }).replace("{\u5546\u54C1\u6570\u91CF}", "")))), item.failedData.length > 0 && /* @__PURE__ */ React.createElement("div", {
    className: "list-item",
    key: item.shopName
  }, /* @__PURE__ */ React.createElement(Tooltip, {
    title: item.shopName || "-"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "store-name"
  }, item.shopName, ":")), /* @__PURE__ */ React.createElement("div", {
    className: "success-desc"
  }, /* @__PURE__ */ React.createElement(Tooltip, {
    title: item.failedData.map((failedData) => {
      return /* @__PURE__ */ React.createElement("p", {
        key: `${failedData.sourceProductId}.errMsg`
      }, /* @__PURE__ */ React.createElement("span", null, "selectProducts" in CopyTaskInfo ? CopyTaskInfo.selectProducts.find((product) => product.id === failedData.sourceProductId)?.name : failedData.sourceProductId, ":", " "), failedData.errorMsg);
    })
  }, /* @__PURE__ */ React.createElement("span", {
    className: "success-count-error"
  }, item.failedData.length), /* @__PURE__ */ React.createElement("span", {
    className: "success-tip"
  }, formatMessage({
    id: "copyFailedResult"
  }).replace("{\u5546\u54C1\u6570\u91CF}", "")))))))), /* @__PURE__ */ React.createElement("div", {
    className: "results-content-btn"
  }, haveSuccessFlag && /* @__PURE__ */ React.createElement(Button, {
    onClick: () => handelCancelToDrafts(),
    style: {marginRight: 16}
  }, formatMessage({id: "draft"})), haveSuccessFlag ? ["BUKALAPAK_ID", "SHOPEE_ID", "WOO_COMMERCE_ID", "TOKOPEDIA_ID", "LAZADA_ID", "TIKTOK_ID"].includes(channelId) ? /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: () => editNow()
  }, formatMessage({id: "EditNow"})) : /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: () => handelViewNow()
  }, formatMessage({id: "viewNow"})) : /* @__PURE__ */ React.createElement(Button, {
    onClick: () => handelCancelResults(false)
  }, formatMessage({id: "close"}))))));
});
export default injectIntl(CloneResultsModal);
